import React, { FC } from "react";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";
import keyword_1 from '../../images/monitoringScreens/keyword_1.jpg';
import keyword_2 from '../../images/monitoringScreens/keyword_2.jpg';
import keyword_3 from '../../images/monitoringScreens/keyword_3.jpg';
import keyword_4 from '../../images/monitoringScreens/keyword_4.jpg';
import keyword_5 from '../../images/monitoringScreens/keyword_5.jpg';
import './styles.scss';

const KeywordMonitoring: FC = () => (
  <div className="content-wrapper">
    <PageHero
      title="Keyword monitoring"
      subtitle="Monitor web pages for the presence or absence of specific keywords."
    />
    <Layout>
      <Section>
        <div className="col-lg-12 keyword-monitoring">
          <iframe src="https://www.youtube.com/embed/vn-Rkw_2xck?rel=0"
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>

          <h2>Keyword monitor - Walkthrough</h2>
          <br />
          <div className="img-block">
            <img src={keyword_1} alt="Select keyword monitoring tool" />
          </div>
          <p className="mb">
            The keyword monitor is great for keeping an eye out for specific
            keywords in a page. This is ideal for picking up mentions of your
            brand, checking for special offers or picking up on specific errors
            on a page.
          </p>

          <div className="img-block">
            <img src={keyword_2} alt="Preview desired URL" />
          </div>
          <p className="mb">
            To get started enter the url you want to check and click preview.
          </p>

          <div className="img-block">
            <img src={keyword_3} alt="Choose to monitor for the presence of one or more keywords" />
          </div>
          <p className="mb">
            Once the page has loaded, you can choose to monitor for the
            presence of one or more keywords. Use the vertical pipe character
            to check for the presence of a keyword, and the presence of
            another. Alternatively use a comma to check for the presence of
            any number of different keywords.
          </p>

          <div className="img-block">
            <img src={keyword_4} alt="You can choose the frequency of the checks" />
          </div>
          <p className="mb">
            Next, you can choose the frequency of the checks, your preferred
            notification channels, as well set custom start and end dates.
          </p>

          <div className="img-block">
            <img src={keyword_5} alt="click start monitoring to get started" />
          </div>
          <p className="mb">
            Then click start monitoring to get started. Hexowatch will keep an
            eye on the page and will notify you when the keywords are
            detected.
          </p>
        </div>
      </Section>
    </Layout>
  </div>
);

export default KeywordMonitoring;
